import React, { useState } from 'react';

function FloatingButton() {
  const [isButtonShown, setIsButtonShown] = useState(true);

  const handleClick = () => {
    console.log('Button clicked!');
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isButtonShown = scrollTop > 300;

    setIsButtonShown(isButtonShown);
  };

  window.addEventListener('scroll', handleScroll);

  return (
    <div >
      {isButtonShown && (
        <button className="floating-button" onClick={handleClick}>
          Click me!
        </button>
      )}
    </div>
  );
}

export default FloatingButton;